const ddados = {
  Titulo: "Solicitar Documento",
  Campos: {
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF / CNPJ",
      Tooltip: "CPF / CNPJ",
      Obrigatorio: true,
    },
    EmailSolicitante: {
      Tipo: "text",
      Mascara: "email",
      Label: "Solicitante",
      Tooltip: "Solicitante",
      Obrigatorio: true,
    },
    EmailEmpresa: {
      Tipo: "text",
      Mascara: "email",
      Label: "Empresa",
      Tooltip: "Empresa",
      Obrigatorio: true,
    },
    SolicitarDocumentoSuggestion: {
      Tipo: 'suggestion',
      Label: 'Documento',
      Tooltip: 'Identificador e Descrição do Documento',
      Placeholder: 'Documento'
    },
  }
};

export { ddados };
